/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from 'react'

import { useForm } from "react-hook-form"

import Menu from '../../../../components/CustomerClub/Menu'
import { notify } from '../../../../components/Toast'

import 'react-modern-calendar-datepicker/lib/DatePicker.css'
import DatePicker from '@taak/react-modern-calendar-datepicker'

import compaignIcon from '../../../../assets/svg/Compaign.svg'
import { post } from '../../../../services/http'

import { useNavigate } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'

function index() {
  document.title = 'ایجاد کمپین'

  const navigate = useNavigate()

  // eslint-disable-next-line no-unused-vars
  const [clickButton, setClickButton] = useState(false)
  const [selectedDay, setSelectedDay] = useState('')
  const [timePartCount, setTimePartCount] = useState(2)
  const [timePart, setTimePart] = useState([{ id : 1 }])

  const token = localStorage.getItem('token')

  const { register, handleSubmit } = useForm()

  const onSubmit = (data, e) => {
    e.preventDefault()

    e.preventDefault()
    let count = 1
    const timesArray = []
    while(count < timePartCount) {
      const item =  {
        step: data['days' + count],
        des: data['time' + count]
      }
      timesArray.push(item)
      count++
    }

    post(`/api/admin/campaign?token=${token}`, {
      'name': data.name,
      'time': `${selectedDay.year}/${selectedDay.month}/${selectedDay.day}`,
      'type': data.type,
      'money': data.money,
      'steps': JSON.stringify(timesArray),
      'description': data.description
    }).then(response => {
      notify('success', response.data.messageFa)
      setTimeout(() => {
        navigate('/cc/campaigns')
      }, 2000)
    })
    .catch(error => {
      setClickButton(false)
      if (error) {
        notify('error', error)
      }
      notify('error', 'خطا در ارسال اطلاعات')
    })
  }

  const timeHandler = () => {
    setTimePartCount(timePartCount + 1)
    setTimePart(oldArray => [...oldArray, { id : timePartCount}])
  }

  return (
    <main id='panel'>
      <ToastContainer rtl />
      <Menu page={'campaigns'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className="right">
              <div className='icon'>
                <img src={compaignIcon} alt='resturantIcon' />
              </div>
              <div className='text'>
                ایجاد کمپین
              </div>
            </div>
            <div className="left">
            </div>
          </div>

          <form className='form' onSubmit={handleSubmit(onSubmit)}>
            <div className='title'>
              * نوشتن جزئیات هر کمپین می تواند شما را در اجرای آن موفق تر و هدفمند تر کند.
            </div>
            <div className='lineTitleFood'>
              <hr />
              اطلاعات کمپین
              <hr />
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='foodName'>نام کمپین * :</label>
                <input id='foodName' {...register("name", { required: true, minLength: 3 })} type='text' placeholder='مثلا کمپین بهاری' />
                <small id='foodNameAlert'>نام کمپین باید وارد شود</small>
              </div>
              <div className='column'>
              </div>
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='foodLevele'>تاریخ اجرا * :</label>
                <DatePicker
                  value={selectedDay}
                  onChange={setSelectedDay}
                  shouldHighlightWeekends
                  locale="fa" // add this
                />
                <small id='foodLeveleDetailsAlert'>تاریخ اجرا باید وارد شود</small>
              </div>
              <div className='column'>
                <label htmlFor='resturantName'>نوع کمپین * :</label>
                <select id='categoryName' {...register("type", { required: true })}>
                  <option value="اینستاگرام">اینستاگرام</option>
                  <option value="sms">sms</option>
                  <option value="سایت">سایت</option>
                  <option value="تبلیغات محیطی">تبلیغات محیطی</option>
                  <option value="کمپین 360">کمپین 360</option>
                  <option value="اینفلوئنسر مارکتینگ">اینفلوئنسر مارکتینگ</option>
                </select>
                <small id='resturantNameAlert'>نوع کمپین باید انتخاب شود</small>
              </div>
            </div>
            <div className="row">
              <div className='column'>
                <label htmlFor='foodName'>بودجه (تومان) * :</label>
                <input id='offCodePercent' {...register("money", { required: true, minLength: 1 })}  className='ltrdirection' type='text' placeholder='25000' />
                <small id='foodNameAlert'>بودجه کمپین باید وارد شود</small>
              </div>
              <div className='column'>
              </div>
            </div>
            <div className='lineTitleFood'>
              <hr />
              گام های کمپین
              <hr />
            </div>
            {timePart.map((item, index) => (
              <div className='row' key={index} id={item.id}>
                <div className='column'>
                  <label htmlFor='resturantDay'>گام ها * :</label>
                  <input id='resturantDay' {...register(`days${item.id}`, { required: true, minLength: 3 })} type='text' placeholder='دعوت از' />
                  <small id='resturantDayAlert'>گام ها باید وارد شود</small>
                </div>
                <div className='column'>
                  <label htmlFor='resturantTime'>توضیحات * :</label>
                  <input id='resturantTime' {...register(`time${item.id}`, { required: true, minLength: 3 })} type='text' placeholder='علی کریمی' />
                  <small id='resturantTimeAlert'>توضیحات باید وارد شود</small>
                </div>
              </div>
            ))}
            <div className="row">
              <div className="add" onClick={timeHandler}>
                +
              </div>
            </div>
            <div className='lineTitleFood'>
              <hr />
              توضیحات کمپین
              <hr />
            </div>
            <div className='row'>
              <div className='column textarea'>
                <label htmlFor='foodDetail'>توضیحات * :</label>
                <textarea id='foodDetail' rows={5} placeholder='توضیحات' {...register("description", { required: true })} />
                <small id='foodDetailAlert'>توضیحات باید وارد شود</small>
              </div>
            </div>
            <button className='createButton' type='submit' style={clickButton ? { backgroundColor: 'gray' } : {}} disabled={clickButton ? true : false}>{clickButton ? 'در حال آپلود ...' : 'ایجاد کمپین'}</button>
          </form>

          <div className="copyright">
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}

export default index